import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import Logo from '../../assets/intro/images/logo.png';
import Video from '../../assets/intro/video/NewGTIntro.mp4';
import { gameStore } from '../../store/gameStore';
import { userSettingsStore } from '../../store/userSettingsStore';
import { specificLocalStorageKeys } from '../../constants';
import { loadingStore } from '../../store/loadingStore';

const IntroContent = observer(() => {
  const [state, setState] = useState(false);
  const introClose = () => {
    userSettingsStore.setGameSpecificLocalStorageDataByKey(
      specificLocalStorageKeys.isHideIntro,
      state
    );
    gameStore.toggleIntroMode(false);
  };

  useEffect(() => {
    if (!userSettingsStore.localStorageData().isHideIntro) {
      gameStore.toggleIntroMode(true);
    }
  }, []);

  if (!gameStore.isIntroMode || loadingStore.progress !== 100) {
    return null;
  }
  return (
    <div className='mainWrapper'>
      <div className='videoAndLogo'>
        <div className='gameLogoHolder'>
          <img className='gameLogo' src={Logo} alt='#' />
        </div>
        <div className='videoHolder'>
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video
            className='gameVideo'
            id='html5'
            playsInline='false'
            src={Video}
            autoPlay
            muted
            loop
          />
        </div>
      </div>
      <div className='bottomRow'>
        <button className='playButton' onClick={() => introClose()}>
          <span className='playButtonText'>play</span>
        </button>
        <div className='textHolder'>
          <input
            className='checkbox'
            type='checkbox'
            id='test'
            onClick={() => {
              setState(!state);
            }}
          />
          <label className='checkboxText' htmlFor='test'>
            don't show again
          </label>
        </div>
      </div>
    </div>
  );
});

export default IntroContent;
